import GenericModal from "../../../../../common/GenericModal";
import GenericSelect from "../../../../../common/GenericSelect";
import GenericInput from "../../../../../common/GenericInput";
import { SelectChangeEvent } from "@mui/material/Select";
import { useState } from "react";
import { updateCustomQuestions } from "../../../../../store/steps/stepFourSlice";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { useDispatch } from "react-redux";

const questionTypes: string[] = STATIC_STRINGS.questionTypes;

const CustomQuestionModal = ({ isModalOpen, setModalOpen }) => {
  const dispatch = useDispatch();
  const [customQuestion, setCustomQuestion] = useState("");
  const [customQuestionType, setCustomQuestionType] = useState("");

  const handleAddCustomQuestion = () => {
    if (
      customQuestion &&
      customQuestionType !== STATIC_STRINGS.TYPE_OF_QUESTION
    ) {
      dispatch(
        updateCustomQuestions({
          question: customQuestion,
          questionType: customQuestionType,
          include: true,
        })
      );
      setCustomQuestion("");
      setCustomQuestionType(STATIC_STRINGS.TYPE_OF_QUESTION);
      setModalOpen("");
    }
  };
  return (
    <GenericModal
      open={isModalOpen}
      onClose={() => setModalOpen("")}
      onConfirm={handleAddCustomQuestion}
      confirmColor="outline"
      title={STATIC_STRINGS.ADD_CUSTOM_QUESTION}
      body={
        <div className="flex flex-col justify-center items-center">
          <GenericInput
            className="w-4/5 mx-auto"
            type="text"
            value={customQuestion}
            onChange={(e) => setCustomQuestion(e.target.value)}
            placeholder={STATIC_STRINGS.CUSTOM_QUESTION_PLACEHOLDER}
          />
          <div className="mt-2 w-full">
            <GenericSelect
              className="w-4/5 mx-auto"
              value={customQuestionType || STATIC_STRINGS.TYPE_OF_QUESTION}
              onChange={(e: SelectChangeEvent) => {
                setCustomQuestionType(e.target.value);
              }}
              options={[
                {
                  label: STATIC_STRINGS.TYPE_OF_QUESTION,
                  value: STATIC_STRINGS.TYPE_OF_QUESTION,
                },
                ...questionTypes.map((type) => ({ label: type, value: type })),
              ]}
            />
          </div>
        </div>
      }
    />
  );
};

export default CustomQuestionModal;
